export const IS_SIGNED_INTO_CABLE = "IS_SIGNED_INTO_CABLE"
export const IS_SIGNED_INTO_MPX = "IS_SIGNED_INTO_MPX"
export const IS_POLARIS = "IS_POLARIS"
export const HAS_ACCESS_TO_MPX_VIEW = "HAS_ACCESS_TO_MPX_VIEW"

// Rules management
export const RULE_SET_HAS_RULES = "RULE_SET_HAS_RULES"
export const RULE_COLLECTION_HAS_RULES_SETS = "RULE_COLLECTION_HAS_RULES_SETS"

// Service getters
export const MVATS_WEB_SERVICE_URL = "MVATS_WEB_SERVICE_URL"
export const MVATS_TRANSFORMATION_SERVICE_URL =
  "MVATS_TRANSFORMATION_SERVICE_URL"
export const RULE_MGMT_DATA_SERVICE_URL = "RULE_MGMT_DATA_SERVICE_URL"
export const VOD_SYCN_EVENT_DATA_SERVICE_URL =
  "VOD_SYCN_EVENT_DATA_SERVICE_URL"
export const VOD_SYCN_OFFERING_DATA_SERVICE_URL =
  "VOD_SYCN_OFFERING_DATA_SERVICE_URL"
export const VOD_SYCN_OFFERING_WEB_SERVICE_URL =
  "VOD_SYCN_OFFERING_WEB_SERVICE_URL"
export const VOD_SYCN_PREINGEST_DATA_SERVICE_URL =
  "VOD_SYCN_PREINGEST_DATA_SERVICE_URL"
export const VOD_SYCN_PREINGEST_WEB_SERVICE_URL =
  "VOD_SYCN_PREINGEST_WEB_SERVICE_URL"
export const VOD_SYCN_TEMPLATE_DATA_SERVICE_URL =
  "VOD_SYCN_TEMPLATE_DATA_SERVICE_URL"



// WEBPACK FOOTER //
// ./src/store/constants/getter-types.js